
import { ERR_CANNOT_GET_DATA_FROM_SERVER } from "../../constants"
import { createGenericAuthRequest, createPostRequest } from "../request/request-utils"

const BASE_URL = process.env.REACT_APP_ELEARN_URL || '/'
const BASE_PATH = "/timed-sprints"
const request = createGenericAuthRequest(BASE_URL)
const requestPost = createPostRequest(BASE_URL)

async function initializeSprint(sprintId: string, testTimeIndicator: string) {
    let url = `${BASE_PATH}/user/init/${sprintId}/${testTimeIndicator}`
    return requestPost(url)
}

async function getAllUserSprints() {
    return request(`${BASE_PATH}/user`)
}

async function getSprint(sprintId: string) {
    return request(`${BASE_PATH}/user/${sprintId}`)
}

async function getFullSprintWithUserAnswers(sprintId: string) {
    return request(`${BASE_PATH}/user/full/${sprintId}`)
}

export const SprintsRest = {
    saveAnswer: (update: {timedSprintId: string, questionNumber: number, correctAnswer: string, userSubmittedAnswer: string, bookmarked: boolean, studyTimeInSeconds: number, remainingTimeInSeconds: number}) => requestPost(`${BASE_PATH}/user`, JSON.stringify(update)),
    saveProgress: (update: {timedSprintId: string, currentQuestionIndex: number, remainingTimeInSeconds: number}) => requestPost(`${BASE_PATH}/user/meta`, JSON.stringify(update)),
    initializeSprint,
    getSprint,
    getAllUserSprints,
    getFullSprintWithUserAnswers,
    getTeacherStudentsStats: () => request<import("./teacher-stats").TeacherSprintStats>(`${BASE_PATH}/teacher/students/test-results/stats`),
}
